module.exports = __webpack_public_path__ + "76f17ae1a57e8cd02adb5b5aa75a17ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-wakarimasu.png
// module id = 2027
// module chunks = 4